export default "__VITE_ASSET__CH7rRMk0__"